import React from 'react'
import { ElementProps } from '../base/element'

import { IContainerComponent } from '../schemamanager/types'

export interface IPanelComponent extends IContainerComponent {
  type: 'panel'
}

export const Panel = ({children, mergeStyles, events}: ElementProps) => {
  const m = mergeStyles({main: {classes: {}}})

  return <div {...m.main} {...events()}>{children}</div>
}
